import React from 'react';
import styled from 'styled-components'
import { backYouTheme } from '../../../../theme';
import Box from '@mui/material/Box';
import TooltipSimple from '../../common/tooltips/TooltipSimple.jsx';
import { useTranslation } from 'react-i18next';
import { TeamMember } from '../../../../interfaces/team-member';

const CardContainer = styled.div`
	.line-height-1 {
		line-height: 1rem;
	}

	.text-truncate {
		max-width: 200px;
	}
`;

const TilesInfo = styled(Box)({
	padding: '2px',
	width: '3.2rem',
	'.btn-tile-others-contacts': {
		height: '50%',
		width: '100%',
		padding: '6px 0 0 0',
		borderRadius: '0 .38rem 0 0'
	},
	'.btn-tile-requests-count': {
		height: '50%',
		padding: '6px 0 0 0',
		marginTop: '2px',
		borderRadius: '0 0 .38rem 0',
		cursor: 'default!important'
	},
	'.btn-tile-full': {
		height: '100%',
		borderRadius: '0 .38rem .38rem 0',
	},
	'.btn-tile-requests-count.btn-tile-full': {
		marginTop: 0
	},
	'.badge-tile-info': {
		borderRadius: '50%',
		border: 'none',
		fontSize: '12px',
		fontFamily: backYouTheme.typography.fontFamily,
		fontWeight: '900',
		width: '15px',
		zIndex: 5,
		height: '15px',
		lineHeight: '14px'
	},
	'.badge-requests-other-contacts-count': {
		top: '-20px',
		right: '-5px',
	},
	'.badge-requests-customer-count': {
		top: '-20px',
		right: '-7px',
	}
});

interface Props {
	manager: TeamMember,
	linkProps?: any,
	icon?: string,
	textColor?: string
	othersManagersCount?: number
	displayPhoneAndEmail?: boolean
}

export default function CardManager(props: Props){
	const { 
		manager = {},
		linkProps = null,
		icon = '',
		textColor = '',
		othersManagersCount = 0,
		displayPhoneAndEmail = true
	} = props

	const { t: gctrad } = useTranslation();
	
	const cardElement = 
		<CardContainer className="card flex-row border-none bg-white text-gc-dark-blue h-100">

			<div className="d-flex align-items-center my-auto p-3">
				<div className="mr-2">
					<i className={icon + " " + textColor}></i>
				</div>
				<div>
					<div className={"h6 font-weight-bold m-0 text-truncate line-height-1 "+textColor}>
						{manager.firstName} {manager.lastName}
					</div>
						{displayPhoneAndEmail && manager.phone && 
							<div className="small font-weight-normal line-height-1">
								{manager.phone}
							</div>
						}
						{displayPhoneAndEmail && manager.email && 
							<div className="small font-weight-normal line-height-1">{manager.email}</div>
						}
				</div>
			</div>

			{ 0 < othersManagersCount && (
				<TilesInfo className="d-flex flex-column flex-nowrap">
					<TooltipSimple title={othersManagersCount + ' ' + gctrad('responsable secondaire',{count: othersManagersCount})} style={{height:'100%'}}>
						<span className={"btn d-flex justify-content-center align-items-center bg-gc-light-blue-dark text-gc-dark-blue js-nav get_part_link btn-tile-full"}>
							<i className="position-relative fa-kit fa-clients fa-sm">
								<span className={`badge-gc-dark-blue position-absolute badge-tile-info badge-requests-other-contacts-count requests-other-contacts-count`}>
									<span>{othersManagersCount > 9 ? '·' : othersManagersCount}</span>
								</span>
							</i>
						</span>							
					</TooltipSimple>
				</TilesInfo>
			)}

		</CardContainer>
	;

	return (
		<>
			{linkProps ? (
				<a {...linkProps}>
					{cardElement}
				</a>
			) : cardElement}
		</>
	);
}